module.exports = __webpack_public_path__ + "img/jaelyn-circle.87fc70cd.png";